import { useEffect, useRef, useState } from 'react';
import { PlusCircle, MinusCircle } from 'react-feather';

const ShowLess = ({
  items = [],
  itemsToShow = 4,
  defaultHide = true,
  projects = null,
  setProjects = null,
  component = null,
  setExpandButtonRefs = null,
  isReadOnly = false,
}) => {
  const [shownItems, setShownItems] = useState([]);
  const [defaultItemsHidden, setDefaultItemsHidden] = useState(true);
  const [expand, setExpand] = useState('Show More');
  const expandButtonRefs = useRef();

  useEffect(() => {
    if (setExpandButtonRefs) {
      setExpandButtonRefs(expandButtonRefs);
    }
  }, [expandButtonRefs]);

  useEffect(() => {
    if (projects === null) {
      setDefaultItemsHidden(defaultHide);
    }
  }, [defaultHide]);

  useEffect(() => {
    if (projects === null) {
      updateItems();
    }
  }, [items, itemsToShow, defaultItemsHidden]);

  const updateItems = () => {
    const numberOfItemsToShow = defaultItemsHidden ? itemsToShow : items?.length;
    const newItems = [];
    for (let i = 0; i < numberOfItemsToShow; i++) {
      newItems.push(items[i]);
    }

    setShownItems(newItems);
  };

  const toggleHiddenState = () => {
    setDefaultItemsHidden(!defaultItemsHidden);
    updateItems();
  };

  const styles = () => {
    let style = { position: '', display: 'block', marginLeft: '', padding: '' };
    if (projects) {
      if (location.pathname !== '/csm-client-playbook' && location.pathname !== '/engagement-stats') {
        style.position = 'absolute';
        style.display = '';
        style.marginLeft = isReadOnly ? '29px' : '56px';
      }
      if (location.pathname === '/projects' || location.pathname === '/home') {
        style.position = 'absolute';
        style.marginLeft = component === 'engineers' ? '189px' : '93px';
        style.bottom = '22px';
      }
    } else {
      if (location.pathname === '/departments') {
        style.padding = '6px';
      }
      if (location.pathname === '/installments') {
        style.marginLeft = '11px';
      }
      if (location.pathname === '/admin/skills') style.marginLeft = '200px';
    }
    return style;
  };

  const seeMoreButton = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    color: '#2176FF',
    cursor: 'pointer',
    display: styles().display,
    textAlign: 'left',
    display: 'inline-block',
    marginTop: isReadOnly ? '0px' : '10px',
    bottom: styles().bottom,
    padding: styles().padding,
    width: 115,
  };

  const showWrapper = {
    fontSize: '12px',
  };
  const minimizeOutlined = {
    fontSize: '18px',
  };

  const handleExpand = () => {
    if (expand == 'Show More') {
      setProjects(projects);
      setExpand('Show Less');
    } else {
      setProjects(projects.slice(0, 2));
      setExpand('Show More');
    }
  };

  return (
    <>
      {location.pathname === '/project-managers' ? (
        <div>
          {shownItems?.map((item) => item)}
          {items?.length > itemsToShow && (
            <div className="d-inline-block mr-2">
              <span style={seeMoreButton} onClick={toggleHiddenState}>
                {defaultItemsHidden ? (
                  <div>
                    outer_box d-inline-block
                    <PlusCircle size={18} />
                    <span style={showWrapper}> Show More </span>{' '}
                  </div>
                ) : (
                  <div>
                    <MinusCircle size={18} />
                    <span style={showWrapper}> Show Less </span>{' '}
                  </div>
                )}
              </span>
            </div>
          )}
        </div>
      ) : projects !== null ? (
        <span style={seeMoreButton} onClick={handleExpand}>
          {expand == 'Show Less' ? (
            <div>
              <MinusCircle size={18} style={{ marginTop: '-2px',marginRight:'3px' }} />
              <span style={showWrapper} ref={expandButtonRefs}>
                {expand}
              </span>
            </div>
          ) : (
            <div>
              <PlusCircle size={18} style={{ marginTop: '-2px',marginRight:'3px' }} />
              <span style={showWrapper} ref={expandButtonRefs}>
                {expand}
              </span>
            </div>
          )}
        </span>
      ) : (
        <>
          <div className="d-flex align-items-center w-100 flex-wrap">
            {items?.length > 0 ? shownItems?.map((item) => item) : <div className="style-higlight-na-data-fields">N/A</div>}
          </div>
          {items?.length > itemsToShow && (
            <div className="d-inline-block mr-2">
              <span style={seeMoreButton} onClick={toggleHiddenState}>
                {defaultItemsHidden ? (
                  <div>
                    <PlusCircle size={18} />
                    <span style={showWrapper}> Show More </span>{' '}
                  </div>
                ) : (
                  <div>
                    <MinusCircle size={18} />
                    <span style={showWrapper}> Show Less </span>{' '}
                  </div>
                )}
              </span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ShowLess;
